'use client';

import { useEffect, useState } from 'react';
import Link from 'next/link';
import { PeopleMattersLogo } from '@/components/common/Icons';
import { motion } from 'framer-motion';
import OTPVerification from '../Login/OTPVerification';
import { authService } from '@/services/authService';
import { useRouter } from "next/navigation";
import { useAuth } from '@/context/AuthContext';
import { getNames } from 'country-list';
import CustomSelect from '@/app/my-account/CustomSelect';
import InputField from '../CustomInput';
import { useForm } from 'react-hook-form';
import axios from 'axios';
import SocialLogin from '../Login/SocialLogin';
import { useSnackbar } from '@/context/SnackbarContext';
import { useSearchParams } from 'next/navigation';

interface FormData {
  email: string;
  mobile: string;
  fname: string;
  lname: string;
  company_name: string;
  designation: string;
  country_name: string;
  is_subscribe_news_letter: boolean;
  is_accept_terms: boolean;
}

export default function SignupForm({ host }: { host?: string }) {
  const router = useRouter();
  const searchParams = useSearchParams();

  // const [showingOTP, setShowingOTP] = useState(false);
  // const [sessionUser, setSessionUser] = useState(null);
  const { sessionUser, setSessionUser, setSession, fetchSession } = useAuth();
  const { showSnackbar } = useSnackbar();
  const [countryList, setCountryList] = useState<
    { label: string; value: string }[]
  >([]);
  const redirectParam = searchParams?.get('redirect');
  const loginHref = redirectParam
    ? `/auth/login?redirect=${redirectParam}`
    : '/auth/login';

  // const [formData, setFormData] = useState<FormData>({
  //   email: '',
  //   mobile: '',
  //   fname: '',
  //   lname: '',
  //   company_name: '',
  //   designation: '',
  //   country_name: '',
  //   is_subscribe_news_letter: true,
  //   is_accept_terms: false,
  // });
  const [showOTP, setShowOTP] = useState(false);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    control,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      email: '',
      mobile: '',
      fname: '',
      lname: '',
      company_name: '',
      designation: '',
      country_name: '',
      is_subscribe_news_letter: true,
      is_accept_terms: false,
    }
  });

  const values = watch();

  const onSubmit = async (data: FormData) => {
    try {
      // Create a copy of data with trimmed values for submission
      const submissionData = {
        ...data,
        fname: data.fname.trim(),
        lname: data.lname.trim(),
      };

      const response = await authService.register(submissionData);
      if ((response as any)?.success && (response as any)?.data?.messageId) {
        // toast.success("otp sent your email address")
        showSnackbar({
          message: "otp sent your email address",
          type: 'success',
        });
        setShowOTP(true);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        // toast.error(error.response?.data?.message)
        showSnackbar({
          message: error.response?.data?.message,
          type: 'error',
        });
        // console.log('error', error.response?.data?.message);
      } else {
        console.log('error', error);
      }
    }
  };

  // useEffect(() => {
  //   if (Number(sessionUser?.subscriber_id) > 0) {
  //     console.log("Redirecting to home...");
  //     // router.push(`/`);
  //     window.location.href = "/";
  //   }
  // }, [sessionUser]);
  useEffect(() => {
    const temp = getNames().map((name) => ({
      label: name,
      value: name,
    }));
    setCountryList(temp);
  }, []);

  useEffect(() => {
    if (sessionUser) {
      // Check for stored return URL and redirect there, otherwise go to home
      // const returnUrl = getAndClearReturnUrl();
      if (true) {
      // if (returnUrl && returnUrl !== '/') {
        // router.push(returnUrl);
      } else {
        // console.log('SignupForm - redirecting to home');
        router.push('/');
      }
    }
  }, [sessionUser, router]);



  // const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value, type, checked } = e.target;

  //   if (name === 'mobile') {
  //     // Only allow numbers and limit to 10 digits
  //     const numericValue = value.replace(/[^0-9]/g, '').slice(0, 10);
  //     setFormData(prev => ({
  //       ...prev,
  //       [name]: numericValue
  //     }));
  //   } else {
  //     setFormData(prev => ({
  //       ...prev,
  //       [name]: type === 'checkbox' ? checked : value
  //     }));
  //   }
  // };

  // const handleSubmit = async (e: React.FormEvent) => {
  //   e.preventDefault();
  //   if (formValid) {
  //     console.log('Form submitted:', formData);
  //     return
  //     const response = await authService.register(formData);
  //     console.log('response=>', response, (response as any)?.data, response?.status);
  //     if ((response as any)?.success && (response as any)?.data?.messageId) {
  //       console.log('response=>', response);
  //       setShowOTP(true);
  //     }
  //   }
  // };

  const handleOTPVerify = async (otp: string) => {
    try {
      const response = await authService.verifyCreate({ ...values, otp });
      if ((response as any)?.success) {
        const userData = {
          ...(response as any)?.data?.newUser,
          token: (response as any)?.data?.token,
          verified: (response as any)?.data?.verified,
        };
        // console.log('userData', userData);
        localStorage.setItem("peoples_token", (response as any)?.data?.token);
        await setSession(userData);
        // toast.success("Register Successfully!")
        showSnackbar({
          message: "Register Successfully!",
          type: 'success',
        });
        setSessionUser((response as any)?.data?.newUser);
        await fetchSession();
        // await setSessionUser({ ...(response as any)?.data?.newUser, token: (response as any)?.data?.token });

        // Get saved return URL and redirect
        console.log(`🔄 [SIGNUP_FORM] Starting post-authentication redirect`);
        const redirect = searchParams?.get('redirect') || '/';
        console.log(`🎯 [SIGNUP_FORM] Redirecting user to: ${redirect}`);
        router.push(redirect);
      } else {
        // toast.error("Invalid OTP. Please try again.");
        showSnackbar({
          message: "Invalid OTP. Please try again.",
          type: 'error',
        });
      }

    } catch (error) {
      if (axios.isAxiosError(error)) {
        // toast.error(error.response?.data?.message)
        showSnackbar({
          message: error.response?.data?.message,
          type: 'error',
        });
      } else {
        console.log('error', error);
      }
    }
  };

  const handleGoBack = () => {
    // Check if there's browser history to go back to
    if (window.history.length > 1) {
      router.back();
    } else {
      // Fallback to home page if no history
      router.push('/');
    }
  };



  const handleChangeNumber = () => {
    setShowOTP(false);
  };


  return (
    <div className="min-h-screen overflow-hidden flex flex-col items-center justify-center p-4">
      <svg className='fixed bottom-0 left-0 pointer-events-none' width="240" height="276" viewBox="0 0 240 276" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.05" cx="58.5" cy="181.5" r="181.5" fill="#0D121E" />
      </svg>

      {/* Header with Logo and Back button */}
      <div className='w-full max-w-7xl flex justify-center md:justify-between items-center md:mb-16 mt-5'>
        <button onClick={handleGoBack} className="hidden md:inline-block" aria-label="Go back">
          <span className="text-[10px] font-bold tracking-[0.2em]">GO BACK</span>
        </button>
        <div className='ml-5'>
          <PeopleMattersLogo className="h-8" />
        </div>
        <div className="hidden md:inline-block text-right font-medium text-sm">
          <span className="text-orange">*</span>
          <span className="text-orange"> are mandatory fields.</span>
        </div>
      </div>
      {/* responsive */}
      <div className='w-full flex justify-between items-center gap-x-16 mb-16 mt-5 md:hidden'>
        <button onClick={handleGoBack} className="" aria-label="Go back">
          <span className="text-[10px] font-bold tracking-[0.2em]">GO BACK</span>
        </button>
        <div className="text-right font-medium text-[10px]">
          <span className="text-orange">*</span>
          <span className="text-orange"> are mandatory fields.</span>
        </div>
      </div>

      {showOTP && (
        <OTPVerification
          phoneNumber={values.mobile}
          emailId={values.email}
          onVerify={handleOTPVerify}
          onChangeNumber={handleChangeNumber}
          onResendOTP={async () => {
            const response = await authService.register(values);
            if ((response as any)?.success) {
              // toast.success("New OTP sent to your email address");
              showSnackbar({
                message: "New OTP sent to your email address",
                type: 'success',
              });
            }
          }}
        />
      )}
      {!showOTP && <div className="relative overflow-hidden flex flex-col items-center p-4">

        <motion.div
          className="flex-1 flex flex-col items-center justify-start w-full max-w-md mx-auto"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          {/* Form Title */}
          <motion.h1
            className="text-2xl font-semibold text-center text-gray-900 mb-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Signup
          </motion.h1>

          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)} className="w-full space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Email */}
              <InputField
                label="Email"
                name="email"
                placeholder="Email *"
                control={control}
                pattern={{
                  value: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
                  message: 'Invalid email address',
                }}
                required
                type="email"
                error={errors.email?.message}
              />

              {/* Mobile */}
              <InputField
                label="Mobile"
                name="mobile"
                placeholder="Mobile *"
                control={control}
                required
                type="text"
                rules={{
                  required: "Mobile is required",
                  pattern: {
                    value: /^\+?[0-9]{10,13}$/,
                    message: "Enter a valid mobile number",
                  },
                }}
                sanitize={(val: string) => {
                  if (!val) return "";
                  const cleaned = val.replace(/[^0-9+]/g, "");
                  if (cleaned.startsWith("+")) {
                    return "+" + cleaned.substring(1).replace(/[^0-9]/g, "");
                  }
                  return cleaned.replace(/[^0-9]/g, "");
                }}
                error={errors.mobile?.message}
              />

              {/* First Name */}
              {/* only alphabets and space should be typed in first name */}
              <InputField
                label="First Name"
                name="fname"
                placeholder="First Name"
                control={control}
                required
                error={errors.fname?.message}
                rules={{
                  required: "First name is required",
                  pattern: {
                    value: /^[a-zA-Z\s]+$/,
                    message: "Only alphabets are allowed",
                  },
                  validate: (value: string) => {
                    if (!value || value.trim() === '') {
                      return "First name cannot be empty";
                    }
                    return true;
                  },
                }}
                sanitize={(val: string) => {
                  if (!val) return "";
                  // Remove non-alphabetic characters and normalize multiple spaces
                  let filteredValue = val
                    .replace(/[^a-zA-Z\s]/g, '') // Remove non-alphabetic characters
                    .replace(/\s+/g, ' '); // Replace multiple spaces with single space
                  
                  // Remove leading spaces but allow trailing space during typing
                  filteredValue = filteredValue.replace(/^\s+/, ''); // Remove leading spaces
                  
                  return filteredValue;
                }}
              />

              <InputField
                label="Last Name"
                name="lname"
                placeholder="Last Name"
                control={control}
                required
                error={errors.lname?.message}
                rules={{
                  required: "Last name is required",
                  pattern: {
                    value: /^[a-zA-Z\s]+$/,
                    message: "Only alphabets are allowed",
                  },
                  validate: (value: string) => {
                    if (!value || value.trim() === '') {
                      return "Last name cannot be empty";
                    }
                    return true;
                  },
                }}
                sanitize={(val: string) => {
                  if (!val) return "";
                  let filteredValue = val
                    .replace(/[^a-zA-Z\s]/g, '')
                    .replace(/\s+/g, ' ');
                  
                  filteredValue = filteredValue.replace(/^\s+/, '');
                  
                  return filteredValue;
                }}
              />

              <InputField
                label="Company Name"
                name="company_name"
                placeholder="Company Name"
                control={control}
                error={errors.company_name?.message}
              />

              <InputField
                label="Position"
                name="designation"
                placeholder="Position"
                control={control}
                error={errors.designation?.message}
              />

              <CustomSelect
                name="country"
                required={true}
                value={values.country_name}
                onChange={(value) => setValue("country_name", value)}
                options={countryList.map((country) => ({
                  label: country.label,
                  value: country.value
                }))}
                searchable={true}
                placeholder="Select Country"
              />
            </div>

            {/* Checkboxes */}
            <motion.div className="space-y-4" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 0.5 }}>
              <label className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  {...register('is_subscribe_news_letter')}
                  className="w-4 h-4 accent-orange border-gray-300 rounded-xl"
                />
                <span className="text-foreground font-medium text-xs">
                  I agree to subscribe to your newsletter
                </span>
              </label>

              <label className="flex items-center space-x-3">
                <input
                  type="checkbox"
                  {...register('is_accept_terms', {
                    required: 'You must accept terms and conditions'
                  })}
                  className="w-4 h-4 accent-orange border-gray-300 rounded-xl"
                />
                <span className="text-foreground font-medium text-xs">
                  I agree and accept all{' '}
                  <Link href="/terms-and-conditions" className="text-borderGray underline" prefetch={false}>
                    terms and conditions
                  </Link>{' '}
                  and{' '}
                  <Link href="/privacy-and-policy" className="text-borderGray underline" prefetch={false}>
                    privacy policies
                  </Link>
                </span>
              </label>
              {errors.is_accept_terms && (
                <p className="text-xs text-red-500">{errors.is_accept_terms.message}</p>
              )}
            </motion.div>

            <motion.button
              type="submit"
              className={`w-full py-3 rounded-md transition-colors ${isValid
                ? 'bg-orange text-white font-medium'
                : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                }`}
              disabled={!isValid}
              whileHover={isValid ? "hover" : ""}
              whileTap={isValid ? "tap" : ""}
            >
              CREATE AN ACCOUNT
            </motion.button>
          </form>
          <motion.div
            className="text-center text-sm mt-6"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
          >
            <span className="text-gray-600">Already have an account? </span>
            <motion.span whileHover={{ scale: 1.05 }}>
              <Link
                href={loginHref}
                className="text-orange font-medium"
                prefetch={false}
              >
                Login
              </Link>
            </motion.span>
          </motion.div>
        </motion.div>

        <div className="flex-1 flex flex-col items-center justify-start gap-y-9 w-full relative z-10">
          {!showOTP && (
            <>
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t border-gray-200"></div>
                </div>
                <div className="relative flex justify-center text-sm">
                  <span className="px-2 bg-white text-gray-500">OR</span>
                </div>
              </div>

              <SocialLogin host={host} />
            </>
          )}
        </div>
      </div>}


      <svg className='fixed top-0 right-0 pointer-events-none' width="445" height="308" viewBox="0 0 445 308" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.05" cx="397.5" cy="-89.5" r="397.5" fill="#F17C06" />
      </svg>
    </div>
  );
} 